export const getUserPermissions = () => {
    const storedPermissions = sessionStorage.getItem('permissions');
    if (!storedPermissions) return [];
  
    let userPermissions = [];
  
    try {
      userPermissions = JSON.parse(storedPermissions);
      if (!Array.isArray(userPermissions)) {
        userPermissions = [];
      }
    } catch (error) {
      try {
        // Attempt to fix formatting: replace single quotes with double quotes
        const fixedPermissions = storedPermissions.replace(/'/g, '"');
        userPermissions = JSON.parse(fixedPermissions);
        if (!Array.isArray(userPermissions)) {
          userPermissions = [];
        }
      } catch (error2) {
        // Fallback: remove brackets and quotes, then split and trim each permission
        userPermissions = storedPermissions
          .replace(/\[|\]/g, '')
          .split(',')
          .map(perm => perm.replace(/['"]/g, '').trim())
          .filter(Boolean);
      }
    }
    return userPermissions;
  };